import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";

import { GlobalValidators } from "./../../shared/validators/global-validators";

import { ViewStateService } from "./../../shared/services/view-state.service";
import { NotificationsService } from "./../../shared/services/notifications.service";
import { AssessmentService } from "./../shared/services/assessment.service";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

@Component({
  selector: "get-app-email",
  templateUrl: "./get-email.component.html",
})
export class GetEmailComponent implements OnInit, OnDestroy {
  emailForm: UntypedFormGroup;
  personId: string;
  manualValidForm = true;
  onDestroy$ = new Subject();
  //emailFormat = '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$';
  //emailFormat = "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$";

  constructor(
    private formBuilder: UntypedFormBuilder,
    private viewState: ViewStateService,
    private router: Router,
    private route: ActivatedRoute,
    private assessmentService: AssessmentService,
    private notification: NotificationsService
  ) {}

  ngOnInit() {
    this.buildForm();
    this.route.params.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.personId = params["personId"];
    });
    this.viewState.stopLoading();
  }

  isValidEmail() {
    return true;
  }

  onSubmit(updateFormValue) {
    this.formValues = updateFormValue;
    this.viewState.startLoading();
    this.validateForm();
    if (this.emailForm.valid && this.isValidEmail()) {
      this.assessmentService
        .generateCMPAssessmentReport(this.personId, this.formValues.email)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (resp) => {
            this.viewState.stopLoading();
            this.notification.success(
              "Success",
              "The assessment report has been emailed."
            );
            this.router.navigate(["assessment"]);
          },
          (errors) => {
            this.notification.error(
              "Failed",
              "The assessment report has failed to generated."
            );
            this.viewState.stopLoading();
          }
        );
    }
  }

  onBack(event: Event) {
    event.preventDefault();

    this.router.navigate(["assessment"]);
  }

  private buildForm(): void {
    this.emailForm = this.formBuilder.group({
      email: [
        this.formValues.email,
        [Validators.required, Validators.maxLength(150), Validators.email],
      ],
    });
  }

  private validateForm() {
    for (const control in this.emailForm.controls) {
      this.emailForm.controls[control].updateValueAndValidity();
    }

    let hasErrors = false;
    for (const field in this.formErrors) {
      this.formErrors[field] = "";
      const control = this.emailForm.get(field);
      if (control && control.invalid) {
        hasErrors = true;
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + " ";
        }
      }
    }
    if (hasErrors) {
      this.notification.error(
        "Fields Invalid",
        "Please review the form and resubmit."
      );
      this.viewState.stopLoading();
    }
  }

  private formValues = {
    email: "",
  };

  formErrors = {
    email: "",
  };

  validationMessages = {
    email: {
      required: "Email required.",
      maxlength: "Email max length 150 characters.",
      email: "Valid Email Required",
      pattern: "Valid Email Required",
    },
  };

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
